var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourthCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 146,
    viewBox: "0 0 304 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304 45L269.823 45C258.875 45 250 53.8751 250 64.8231V65V94.8231V95C250 106.046 258.954 115 270 115L304 115V145H250C233.431 145 220 131.569 220 115V118C220 105.2 209.623 94.8231 196.823 94.8231H0V64.8231H200.177C211.125 64.8231 220 55.948 220 45C220 28.4315 233.431 15 250 15L304 15V45Z",
    fill: "#33CC66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.761 55.9296C135.159 45.6816 143.419 37.3004 151.971 32.378C171.315 21.2099 186.995 30.2629 186.995 52.5992C187.007 60.8586 184.814 70.1942 180.716 79.3376L171.235 61.6987L179.991 56.6434C179.991 50.2104 178.33 44.8823 175.221 41.3396C172.111 37.7969 167.695 36.2006 162.535 36.7545C157.375 37.3084 151.706 39.9873 146.252 44.4492C140.798 48.9111 135.807 54.9532 131.917 61.8038L128.764 55.9316L128.761 55.9296ZM175.182 89.711C168.784 99.959 160.524 108.34 151.971 113.263C132.628 124.431 116.947 115.378 116.947 93.0415C116.947 84.4475 119.269 75.1397 123.227 66.303L132.708 83.9419L123.952 88.9972C123.952 95.4302 125.613 100.758 128.722 104.301C131.831 107.844 136.248 109.44 141.408 108.886C146.568 108.332 152.237 105.653 157.691 101.191C163.145 96.7296 168.135 90.6874 172.026 83.8368L175.178 89.709L175.182 89.711ZM156.924 81.3981L147.019 75.6796L137.111 92.8372L132.158 89.978L147.019 64.2425L156.924 69.9611L166.832 52.8034L171.784 55.6627L156.924 81.3981Z",
    fill: "#33CC66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.0615,
    height: 97.0615,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 109.942 48.5552)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthCardIcon);
export default __webpack_public_path__ + "static/media/FourthCardIcon.0596de630077124ca54841f6fbae1c90.svg";
export { ForwardRef as ReactComponent };